<h2 mat-dialog-title>Seleccione Orden De Liquidación</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="ordenLiquidacionGroup">
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      formControlName="orden"
    >
      <mat-radio-button
        class="example-radio-button"
        *ngFor="let item of ordenesLiquidacion"
        [value]="item"
        (change)="cerrar($event)"
      >
        {{ item }}
      </mat-radio-button>
    </mat-radio-group>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" (click)="cerrar('')">
    Cancelar
  </button>
</mat-dialog-actions>
